import { FlaskConical, Sparkles } from "lucide-react";

export function QaNotice({ budget, tools = "these image tools" }) {
  return (
    <div className="flex items-start gap-3 rounded-xl border border-amber-300/20 bg-amber-300/[0.06] px-4 py-3" data-testid="qa-notice">
      <FlaskConical className="mt-0.5 h-4 w-4 shrink-0 text-amber-200" />
      <div className="text-xs leading-relaxed text-amber-100/80">
        <p className="font-medium text-amber-100">QA preview — only test accounts can use {tools}.</p>
        <p>Prices are proposed and not live for customers yet. Each run uses real credits.</p>
        {budget && (
          <p className="mt-1 tabular-nums" data-testid="qa-budget-remaining">
            Test budget left: ${budget.remaining_usd.toFixed(2)} of ${budget.limit_usd.toFixed(2)}
          </p>
        )}
      </div>
    </div>
  );
}

// A visual coming-soon state: a drifting collage of real preset covers behind the message.
export function ComingSoonHero({ title, body, covers = [], children, testId = "studio-coming-soon" }) {
  const tiles = [...covers, ...covers].slice(0, 6);
  return (
    <section className="relative isolate overflow-hidden rounded-[28px] border border-white/10 bg-ink-900" data-testid={testId}>
      <div className="absolute inset-0 -z-10 grid grid-cols-3 gap-2 p-2 opacity-60 [mask-image:linear-gradient(to_bottom,black_30%,transparent)]">
        {tiles.map((src, i) => (
          <div key={i} className="overflow-hidden rounded-2xl">
            <img src={src} alt="" className="aspect-[3/4] h-full w-full object-cover animate-ken-burns" style={{ animationDelay: `${i * -2.3}s` }} />
          </div>
        ))}
      </div>
      <div className="absolute inset-0 -z-10 bg-gradient-to-t from-ink-950 via-ink-950/85 to-ink-950/10" />
      <div className="flex min-h-[380px] flex-col justify-end gap-3 p-6 sm:min-h-[420px] sm:p-10">
        <span className="inline-flex w-fit items-center gap-1.5 rounded-full border border-amber-300/30 bg-amber-300/10 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.16em] text-amber-200">
          <Sparkles className="h-3.5 w-3.5" /> Coming soon
        </span>
        <h2 className="max-w-xl text-2xl font-bold tracking-tight text-white sm:text-3xl">{title}</h2>
        <p className="max-w-lg text-sm leading-relaxed text-zinc-400">{body}</p>
        {children}
      </div>
    </section>
  );
}
